function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.572,
  cy: 28.572,
  r: 28.572,
  fill: "#EBEAED"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 58,
  height: 58
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28.572,
  cy: 28.572,
  r: 28.572,
  fill: "#EBEAED"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.572 39.018c5.768 0 10.447-5.22 10.447-11.652 0-6.433-4.68-11.652-10.447-11.652-5.767 0-10.446 5.22-10.446 11.652 0 6.433 4.68 11.652 10.446 11.652zm9.286 2.59h-3.997a11.555 11.555 0 01-5.289 1.294c-1.886 0-3.67-.47-5.288-1.295h-3.997c-5.13 0-9.286 4.637-9.286 10.357v1.295c0 2.144 1.56 3.884 3.482 3.884h30.179c1.922 0 3.482-1.74 3.482-3.884v-1.295c0-5.72-4.157-10.357-9.286-10.357z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.572 58.095a9.524 9.524 0 100-19.047 9.524 9.524 0 000 19.047z",
  fill: "#FF4040",
  stroke: "#FF4040",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M51.428 45.714l-5.714 5.714M45.714 45.714l5.714 5.714",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPersonError = function SvgPersonError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personError.0352ba17.svg";
export { ForwardRef as ReactComponent };